import { useTranslation } from "react-i18next";

import { FilterHeader } from "@shared/table/headers/FilterHeader";

const statuses = ["available", "deleted", "hidden"] as const;

type Props = {
    value: string[];
    onChange: (value: string[]) => void;
};

export const OtaStatusHeader = ({ value, onChange }: Props) => {
    const { t } = useTranslation(["common", "modals"]);
    const options = statuses.map((status) => ({ key: status, label: t(`common:label.${status}`) }));

    return (
        <FilterHeader
            title={t("modals:filterDialog.variants.status")}
            sortDisabled
            options={options}
            initialValues={Object.fromEntries(options.map((o) => [o.key, value.includes(o.key)]))}
            onSubmit={(values) => {
                onChange(Object.keys(values).filter((k) => values[k]));
            }}
        />
    );
};
